<template>
	<div class="course-overview-card">
		<div class="course-overview-card__thumbnail">
			<img :src="thumbnailSrc" :alt="productVariant.product.friendlyTitle" />
		</div>
		<div class="course-overview-card__info">
			<span v-if="!isActiveEnrollment" class="course-overview-card__status-badge course-overview-card__status-badge--inactive-enrollment">Unenrolled/Expired</span>
      <span v-else
				class="course-overview-card__status-badge"
				:class="isCompleted ? 'course-overview-card__status-badge--completed' : 'course-overview-card__status-badge--in-progress'"
			>
				{{ isCompleted ? 'Completed' : 'In Progress' }}
			</span>
			<h1 class="course-overview-card__title">{{ productVariant.product.title }}</h1>
			<div class="course-overview-card__meta">
				<span>{{ productVariant.title }}</span>
				<span class="course-overview-card__meta-dot">·</span>
				<span><i class="fas fa-book-open"></i> {{ totalModules }} modules</span>
			</div>
			<div class="course-overview-card__progress">
				<div class="course-overview-card__progress-header">
					<span class="course-overview-card__progress-label">Overall Progress</span>
					<span class="course-overview-card__progress-value">{{ progress }}%</span>
				</div>
				<div class="course-overview-card__progress-track">
					<div
						class="course-overview-card__progress-fill"
						:style="{ width: progress + '%' }"
					></div>
				</div>
			</div>
			<div class="course-overview-card__actions">
				<button class="course-overview-card__cta-btn" @click="$router.push(continueURL)" :disabled="!isActiveEnrollment">
					<i class="fas fa-play"></i>
					{{ progress > 0 ? 'Continue Learning' : 'Start Learning' }}
				</button>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "CourseOverviewCard",
	props: {
		productVariant: { type: Object, required: true },
		progress:       { type: Number, default: 0 },
		continueURL:    { type: String, required: true },
		totalModules:   { type: Number, default: 0 },
	},
	data() {
		return { isThumbnailError: false };
	},
	computed: {
    isActiveEnrollment() {
      return this.productVariant?.subscriptionStatus?.toLowerCase() === "allowed";
    },
		isCompleted() {
			const isActive = this.productVariant?.subscriptionStatus?.toLowerCase() === "allowed";
			return isActive && this.progress === 100;
		},
		thumbnailSrc() {
			if (this.isThumbnailError) {
				return require(`@/assets/images/image-error.png`);
			} else {
				if (this.productVariant.thumbnailPath) {
					var path = !this.productVariant.thumbnailPath.includes("http")
						? require(`@/${this.productVariant.product.thumbnailPath}`)
						: this.productVariant.thumbnailPath;
					return path;
				}else return require(`@/${this.productVariant.product.thumbnailPath}`);
			}
		}
	},
};
</script>

<style scoped>
.course-overview-card {
	display: flex;
	background: #fff;
	border-radius: 8px;
	border: 1px solid var(--border-color);
	overflow: hidden;
	margin-bottom: 20px;
	height: 220px;
}
.course-overview-card__thumbnail {
	width: 30%;
	min-width: 200px;
	flex-shrink: 0;
}

.course-overview-card__thumbnail img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

.course-overview-card__info {
	flex: 1;
	padding: 16px 28px;
	display: flex;
	flex-direction: column;
	gap: 6px;
	overflow: hidden;
}

.course-overview-card__status-badge {
	display: inline-flex;
	align-self: flex-start;
	border-radius: 99px;
	font-size: 0.75rem;
	font-weight: 600;
	padding: 2px 8px;
}

.course-overview-card__status-badge--inactive-enrollment {
	background: #fff1f2;
	color: #e11d48;
	border: 1px solid #fda4af;
}

.course-overview-card__status-badge--in-progress {
  background: #EFF6FF;
  color: #2563EB;
  border: 1px solid #93C5FD;
}

.course-overview-card__status-badge--completed {
	background: #f0fdf4;
	color: #16a34a;
	border: 1px solid #bbf7d0;
}
.course-overview-card__title {
	font-size: 26px;
	font-weight: 700;
	color: #111827;
	margin: 0;
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.course-overview-card__meta {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	font-size: 13px;
	color: #6b7280;
}

.course-overview-card__meta i { font-size: 12px; margin-right: 3px; }

.course-overview-card__meta-dot { color: #d1d5db; }
.course-overview-card__progress {
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.course-overview-card__progress-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.course-overview-card__progress-label {
	font-size: 13px;
	font-weight: 600;
	color: #374151;
}

.course-overview-card__progress-value {
	font-size: 13px;
	font-weight: 700;
	color: #374151;
}

.course-overview-card__progress-track {
	height: 6px;
	background: #e5e7eb;
	border-radius: 99px;
	overflow: hidden;
}

.course-overview-card__progress-fill {
	height: 100%;
	background: var(--primary-color, #dc2626);
	border-radius: 99px;
	transition: width 0.4s ease;
}
.course-overview-card__actions { margin-top: 0.75rem; }

.course-overview-card__cta-btn {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	background: var(--primary-color, #dc2626);
	color: #fff;
	border: none;
	border-radius: 8px;
	padding: 10px 24px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: opacity 0.2s;
}

.course-overview-card__cta-btn:hover { opacity: 0.88; }
@media (max-width: 768px) {
	.course-overview-card {
		flex-direction: column;
		height: auto;
	}

	.course-overview-card__thumbnail {
		width: 100%;
		height: 180px;
		min-width: unset;
	}

	.course-overview-card__info {
		padding: 16px 18px;
		gap: 8px;
	}

	.course-overview-card__title { font-size: 18px; }
}
</style>
